import type { ArcadeStrings } from "./arcade.vi.ts";

/** English twin of `arcade.vi.ts`. */
export const arcadeEn: ArcadeStrings = {
  coins: (n) => `Spent ${n} coins`,
  hintCost: "Using a hint caps this level at 2 stars. Still want it?",
  stuck: "A glass wall has cut off a friend's way home. Undo a few coins or start again.",
  resultCoins: (n, best) =>
    n <= best ? `You spent ${n} coins, as neat as the best solution!` : `You spent ${n} coins, the neatest solution takes only ${best}.`,
  resultRule: (three, two) => `Three stars for ${three} coins or fewer, two stars for ${two} or fewer.`,
  resultHint: "You used a hint, so 2 stars at most.",
};
